import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Pedidos = () => {
  const { id } = useParams(); // ID do pedido (se presente)
  const navigate = useNavigate();
  const [pedidos, setPedidos] = useState([]); // Lista de pedidos
  const [pedido, setPedido] = useState(null); // Detalhes de um pedido específico
  const [loading, setLoading] = useState(true);

  // Função para buscar a lista de pedidos
  const fetchPedidos = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://crmesquita.com.br/api/meus-pedidos/', {
        headers: { Authorization: `Token ${token}` },
      });
      setPedidos(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
      setLoading(false);
    }
  };

  // Função para buscar os detalhes de um pedido específico
  const fetchPedido = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://crmesquita.com.br/api/pedidos/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      });
      setPedido(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
      setLoading(false);
    }
  };

  // UseEffect para decidir qual função chamar (lista ou detalhes do pedido)
  useEffect(() => {
    setLoading(true);
    if (id) {
      fetchPedido(); // Carregar os detalhes do pedido
    } else {
      fetchPedidos(); // Carregar a lista de pedidos
    }
  }, [id]);

  // Exibir carregamento enquanto os dados estão sendo buscados
  if (loading) {
    return <div>Carregando...</div>;
  }

  // Se o `id` estiver presente, mostrar os detalhes de um pedido específico
  if (id && pedido) {
    return (
      <div>
        <h1>Detalhes do Pedido</h1>
        <p><strong>ID do Pedido:</strong> {pedido.id}</p>
        <p><strong>Status:</strong> {pedido.status}</p>
        <p><strong>Endereço:</strong> {pedido.endereco}</p>
        <h2>Itens do Pedido</h2>
        <ul>
          {pedido.itens.map((item) => (
            <li key={item.id}>
              {item.produto_nome} - Quantidade: {item.quantidade}
            </li>
          ))}
        </ul>
        <button
          onClick={() => navigate('/meus-pedidos')} // Voltar para a lista de pedidos
        >
          Voltar para Meus Pedidos
        </button>
      </div>
    );
  }

  // Se o `id` não estiver presente, mostrar a lista de pedidos
  if (!id && pedidos.length === 0) {
    return <div>Você ainda não realizou nenhum pedido.</div>;
  }

  return (
    <div className="pedidos-container max-w-6xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Meus Pedidos</h1>
      <ul>
        {pedidos.map((pedido) => (
          <li
            key={pedido.id}
            className="pedido-item bg-white shadow p-4 mb-4 rounded cursor-pointer"
            onClick={() => navigate(`/meus-pedidos/${pedido.id}`)} // Navegar para os detalhes do pedido
          >
            <p><strong>Data:</strong> {new Date(pedido.data).toLocaleDateString()}</p>
            <p><strong>Produto:</strong> {pedido.produto_nome}</p>
            <p><strong>Preço:</strong> R$ {pedido.preco.toFixed(2)}</p>
            <p><strong>Status:</strong> {pedido.status}</p>
            <p><strong>Endereço:</strong> {pedido.endereco}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Pedidos;